var voted_users_rtlignore_default = {
  "container": "pPPUN",
  "webview": "n0-Dt",
  "avatar_list": "_9wCKu",
  "avatar": "pY0R7",
  "user_avatar": "ZcKcK",
  "modal": "BPYHx",
  "voted_users_modal": "_1fCLg",
  "overlay": "sYzlz",
  "user_card": "QtWSx",
  "user_name": "Ls5K3",
  "voted_users_modal_header": "NEhUp",
  "cta": "_9Cbfi",
  "close_icon": "Jhzgl",
  "title": "YlzCa",
  "member_list_container": "G11v5",
  "member_list": "oLKET",
  "loader": "wDsEK",
  "anonymous_counter": "CSxvK",
  "spinner": "ccq2B",
  "spin": "_2d-re"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
